export enum FeedVerbEnum {
	Post = 'post',
}

export enum FeedGroupEnum {
	User = 'user',
	TimeLine = 'timeline',
	Notification = 'notification',
	Challenge = 'challenge',
}

export enum FeedWebhookTypesEnum {
	NewReaction = 'reaction.new',
	DeletedReaction = 'reaction.deleted',
}

export enum FeedReactionKindsEnum {
	ClapActivity = 'like',
	HeartActivity = 'heartEmoji',
	MuscleActivity = 'muscleEmoji',
	Comment = 'comment',
	CommentLike = 'commentLike',
	Reply = 'reply',
	ReplyLike = 'replyLike',
}

export enum LikeEmojiEnum {
	Clap = ':clap:',
	Heart = ':heart:',
	Muscle = ':muscle:',
	ThumbUp = ':thumbsup:',
}
